export const BillerData = [
  {
    id: "1",
    Code: "BI001",
    Biller: "Shaun Farley",
    Company_Name: "GreenTech Industries",
    Email: "shaun@example.com",
    Phone: "+18647961254",
    Phone_2: "USA",
    Country: "Active",
    image:"user-30.jpg",
  },
  {
    id: "2",
    
    Code: "BI002",
    Biller: "Jenny Ellis",
    Company_Name: "BlueSky Logistics",
    Email: "jenny@example.com",
    Phone: "+13197521863",
    Phone_2: "Germany",
    Country: "Active",
    image:"user-02.jpg",
  },
  {
    id: "3",
    
    Code: "BI003",
    Biller: "Leon Baxter",
    Company_Name: "EcoFarm Organics",
    Email: "leon@example.com",
    Phone: "+18496275831",
    Phone_2: "Japan",
    Country: "Active",
    image:"user-23.jpg",
  },
  {
    id: "4",
    
    Code: "BI004",
    Biller: "Karen Flores",
    Company_Name: "SmartTech Solutions",
    Email: "karen@example.com",
    Phone: "+18731498524",
    Phone_2: "Austria",
    Country: "Active",
    image:"user-35.jpg",
  },
  {
    id: "5",
    
    Code: "BI005",
    Biller: "Michael Dawson",
    Company_Name: "Fresh Supplies",
    Email: "michael@example.com",
    Phone: "+12876928738",
    Phone_2: "Turkey",
    Country: "Active",
    image:"user-34.jpg",
  },
  {
    id: "6",
    
    Code: "BI006",
    Biller: "Karen Galvan",
    Company_Name: "BrightSource Lighting",
    Email: "karen@example.com",
    Phone: "+17534896148",
    Phone_2: "Mexico",
    Country: "Active",
    image:"user-37.jpg",
  },
  {
    id: "7",
    
    Code: "BI007",
    Biller: "Thomas Ward",
    Company_Name: "GlobalTech Industries",
    Email: "thomas@example.com",
    Phone: "+16482479624",
    Phone_2: "France",
    Country: "Active",
    image:"user-34.jpg",
  },
  {
    id: "8",
    
    Code: "BI008",
    Biller: "Aliza Duncan",
    Company_Name: "HealthWell Pharma",
    Email: "aliza@example.com",
    Phone: "+13175964827",
    Phone_2: "Greece",
    Country: "Active",
    image:"user-38.jpg",
  },
  {
    id: "9",
    
    Code: "BI009",
    Biller: "James Higham",
    Company_Name: "HomeStyle Furnishings",
    Email: "james@example.com",
    Phone: "+13875196482",
    Phone_2: "Italy",
    Country: "Active",
    image:"user-35.jpg",
  },
  {
    id: "10",
    
    Code: "BI010",
    Biller: "Jada Robinson",
    Company_Name: "EcoLogistics Partners",
    Email: "robinson@example.com",
    Phone: "+17586143284",
    Phone_2: "China",
    Country: "Active",
    image:"user-40.jpg",
  },
];
